import http from './http.service';

class PublicSettingsService {
    constructor() {
        if (PublicSettingsService.instance) {
            return PublicSettingsService.instance;
        }

        PublicSettingsService.instance = this;
    }

    params() {
        return http.get('/public-settings/params').then(res => res.data);
    }
    locations() {
        return http.get('/public-settings/locations').then(res => res.data);
    }
    addEq(queryObj) {
        return http.get('/public-settings/add-eq', { params: queryObj }).then(res => res.data);
    }
    priceLists() {
        return http.get('/public-settings/price-lists').then(res => res.data);
    }
    priceList(slug) {
        return http.get(`/public-settings/price-list/${slug}`).then(res => res.data);
    }
}

export default new PublicSettingsService();
